import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/ev_charging_stations',
  component: Management,
  redirect: '/ev_charging_stations/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/ev_charging_stations/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listEvChargingStations
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/ev_charging_stations/ListTable'),
          meta: {
            auth: Auth.listEvChargingStations,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/ev_charging_stations/New'),
      meta: {
        auth: Auth.createEvChargingStation
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/ev_charging_stations/Edit'),
      meta: {
        auth: Auth.updateEvChargingStation
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/ev_charging_stations/DetailLayout'),
      meta: {
        auth: Auth.showEvChargingStation
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/ev_charging_stations/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvChargingStation
          }
        },
        // 路书
        {
          path: 'roadbook',
          component: () => import('@/views/charge_stations/details/RoadBook'),
          meta: {
            tabName: 'roadbook', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargeStation
          }
        },
        // 充电桩
        {
          path: 'ev_charging_piles',
          component: () => import('@/views/ev_charging_stations/details/Chargers'),
          meta: {
            tabName: 'chargers', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvChargingStation
          }
        },
        // 费率
        {
          path: 'billing_rules',
          component: () => import('@/views/ev_charging_stations/details/BillingRules'),
          meta: {
            tabName: 'billing_rules',
            auth: Auth.showEvChargingStation
          }
        }
      ]
    }
  ]
}
